import { Alert, Box, Skeleton } from '@mui/material';
import { useEffect, useState } from 'react';
import CardActions from "src/pages/sistema/components/CardActions";
import { FileBlobResponseFields } from 'src/types/files/filesData';
import { useNOTESGrafico } from '../hooks/useNOTESGrafico';

interface SeccionNOTESVisualizarArchivoProps {
  idOperacion: number;
}

const SeccionNOTESVisualizarArchivo = ({ idOperacion }: SeccionNOTESVisualizarArchivoProps) => {
  const { data, isLoading, isError } = useNOTESGrafico(idOperacion);
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    if (data && data[FileBlobResponseFields.File]) {
      const binaryData = data[FileBlobResponseFields.File];
      const blob = new Blob([binaryData]);
      const url = window.URL.createObjectURL(blob);

      setImageUrl(url);

      return () => {
        window.URL.revokeObjectURL(url);
      };
    }
  }, [data]);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <Skeleton variant='rectangular' height={400} />
      </Box>
    );
  }

  if (isError || !data || !data[FileBlobResponseFields.File]) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity='info'>No se encontró gráfico de subyacentes</Alert>
      </Box>
    );
  }

  return (
    <CardActions title='Gráfico de precios de variación de sub-yacentes' icon='mdi:chart-line' colapsable>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          p: 2,
          minHeight: '100px',
        }}
      >
        {imageUrl && (
          <img
            src={imageUrl}
            alt="Gráfico de la Nota Estructurada"
            style={{
              maxWidth: '100%',
              maxHeight: '600px',
              height: 'auto',
              display: 'block',
              borderRadius: '4px',
              boxShadow: '0px 3px 6px rgba(0,0,0,0.1)'
            }}
          />
        )}
      </Box>
    </CardActions>
  );
};

export default SeccionNOTESVisualizarArchivo;
